export default "__VITE_ASSET__Cx67SIED__"